// Theme Readiness Tracker Component
// Tracks theme readiness from within existing DomainThemeProvider
import React, { ReactNode } from 'react';
import { useRegisterContextReadiness } from '../../contexts/ContextReadinessManager';
import { useDomainTheme } from '../../contexts/DomainThemeContext';

interface ThemeReadinessTrackerProps {
  children: ReactNode;
}

export const ThemeReadinessTracker: React.FC<ThemeReadinessTrackerProps> = ({ children }) => {
  const { currentDomain } = useDomainTheme();
  
  // Theme is ready when domain is loaded
  const isReady = Boolean(currentDomain);
  useRegisterContextReadiness('theme', isReady);
  
  return <>{children}</>;
};

export default ThemeReadinessTracker;